/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { comboSuggestionSchema } from "./comboSuggestionSchema.ts";

export const productsComboListQueryAttachLogsSchema = z.boolean().optional().default(false).describe("Флаг для включения логов фильтрации в ответ.");

export const productsComboListPathOrgUnitIdSchema = z.uuid();

export const productsComboListPathProductIdSchema = z.uuid();

export const productsComboListQueryUseHotMenuSchema = z.boolean().optional().default(true).describe("Использовать кэшированные данные (hot combo) из БД");

export const productsComboListStatus200Schema = z.array(comboSuggestionSchema);

export const productsComboListResponseSchema = productsComboListStatus200Schema;
